// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"241":"b4dc697c","464":"40992135","504":"0bb9d920","933":"2ad0a15b","983":"dc6cb9b5"}[chunkId] + ".chunk.js";
};